import { environment } from '@environments/environment';
import { CreateTemplateLimitDto } from '@interfaces/template-limit/create-template-limit.dto';
import { TemplateLimitI } from '@interfaces/template-limit/template-limit.interface';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TemplateLimitService {
  private baseURL = environment.OMNISMART_API_CUSTOMER;
  private slugURL = 'configuration';

  constructor(private readonly httpService: HttpClient) {}

  public createTemplateLimit(body: CreateTemplateLimitDto): Observable<TemplateLimitI> {
    return this.httpService.post<TemplateLimitI>(`${this.baseURL}${this.slugURL}/template-limit`, body);
  }

  public getCustomerTemplateLimits(customerId: string): Observable<TemplateLimitI[]> {
    return this.httpService.get<TemplateLimitI[]>(`${this.baseURL}${this.slugURL}/template-limit-list/${customerId}`);
  }

  public getLoggedCustomerTemplateLimits(): Observable<TemplateLimitI[]> {
    return this.httpService.get<TemplateLimitI[]>(`${this.baseURL}${this.slugURL}/template-limit-list/logged-customer`);
  }

  public checkIfLoggedCustomerHasLimits(): Observable<boolean> {
    return this.httpService.get<boolean>(`${this.baseURL}${this.slugURL}/check-limit/logged-customer`);
  }
}
